module.exports = __webpack_public_path__ + "img/icons-yrykb-sqjl.0f508a00.png";